<template>
    <div class="mob-inject">
        <div class="ai-show-wrap">
            <!-- ai主播組件 -->
            <digitalHuman v-if="videoDom" :videoDom="videoDom" :is-mobile="true" @loaded="videoDomLoaded"></digitalHuman>
            <!-- ai主播所需要的video -->
            <div class="video-wrap">
                <video
                    ref="videoDoms"
                    id="videoDoms"
                    crossorigin="anonymous"
                    :src="videoUrl"
                    loop
                    style="width:216px;height:384px;position: absolute;right: -220px;top: 0;"
                ></video>
            </div>
        </div>

        <div class="add-box" v-if="aiObj.anchor_url == ''">
            <material-select :type="3" @selected="handleSelectedVideo">
                <template slot="body">
                    <div class="add-inject">設置AI主播</div>
                </template>
            </material-select>
        </div>
        <div class="follow-old" v-else>
            <!-- 第一步 -->
            <Steps
                v-if="step1"
                title="選擇影片"
                @onClickNext="onClickNextTo(2)"
            >
                <template slot="body">
                    <div class="base-container">
                        <!-- 影片顯示 -->
                        <div class="video-box">
                            <div class="video-play-btn" @click="playVideo">
                                <a-icon type="pause" v-if="videoPlay"/>
                                <a-icon type="caret-right" v-else/>
                            </div>
                            <video
                                width="100%"
                                height="100%"
                                id="myVideo"
                                muted
                                loop
                                :src="aiObj.anchor_url"
                                style="display: block"
                            ></video>
                        </div>
                        <!-- 操作 -->
                        <div class="rights-box">
                            <div class="adds">
                                <material-select :type="3" @selected="handleSelectedVideo">
                                    <template slot="body">
                                        <div>
                                            <img src="../../assets/img/mob_add_scene.png"/>
                                            <h5>選擇影片</h5>
                                        </div>
                                    </template>
                                </material-select>
                            </div>
                            <div class="adds" @click="delVideo">
                                <div>
                                    <img src="../../assets/img/mob_delete.png"/>
                                    <h5>刪除</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Steps>
            <!-- 第二步 -->
            <Steps
                v-if="step2"
                title="選擇語音"
                :isShowArrow="true"
                @clickBack="onClickPreTo(1)"
                @onClickNext="onClickNextTo(3)"
            >
                <template slot="body">
                    <div class="base-container">
                        <!-- 影片顯示 -->
                        <div class="audio-box">
                            <template v-if="aiObj.speech_explain_url">
                                <!-- 播放按鈕 -->
                                <div class="play-btn" @click="playSpeech">
                                    <a-icon type="pause" v-if="speechPlay"/>
                                    <a-icon type="caret-right" v-else/>
                                </div>
                                <!-- 數據 -->
                                <div class="right-info">
                                    <div class="names">{{aiObj.speech_explain_name}}</div>
                                </div>
                            </template>
                            <span class="tips" v-else>暫無語音</span>
                            <audio
                                id="speechAudio"
                                controls="controls"
                                alt="example"
                                style="display: none"
                                :src="aiObj.speech_explain_url?aiObj.speech_explain_url:''"
                            ></audio>

                        </div>
                        <!-- 操作 -->
                        <div class="rights-box">
                            <div class="adds">
                                <material-select :type="2" @selected="handleSelectedAudio">
                                    <template slot="body">
                                        <div>
                                            <img src="../../assets/img/mob_add_scene.png"/>
                                            <h5>選擇語音</h5>
                                        </div>
                                    </template>
                                </material-select>
                            </div>
                            <div class="adds" @click="delSpeech" v-if="aiObj.speech_explain_url">
                                <div>
                                    <img src="../../assets/img/mob_delete.png"/>
                                    <h5>刪除</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Steps>
            <!-- 第三步 -->
            <Steps
                v-if="step3"
                title="AI去背"
                :isShowArrow="true"
                @clickBack="onClickPreTo(2)"
                @onClickNext="onClickNextTo(4)"
            >
                <template slot="body">
                    <div class="color-wrap">
                        <div class="color-box">
                            顏色值：
                            <div class="boxs">
                                <div class="color-k" :style="{backgroundColor: setColor(aiObj.color)}"></div><span>{{setColor(aiObj.color)}}</span>
                            </div>
                        </div>
                        <Color @change="changeColor"></Color>
                    </div>
                </template>
            </Steps>
            <!-- 第四步 -->
            <Steps
                v-if="step4"
                title="位置設置"
                :isShowArrow="true"
                @clickBack="onClickPreTo(3)"
                @onClickNext="onClickNextTo(5)"
            >
                <template slot="body">
                    <div class="position-box">
                        <div class="set-box">
                            <div class="labels">位置</div>
                            <div class="con-box">
                                <div class="lists" :class="{active: item == aiObj.position}" @click="aiObj.position = item" v-for="(item,index) in position" :key="index"><img :src="require(`@/assets/img/position_${item}.png`)"/></div>
                            </div>
                        </div>
                        <div class="set-box">
                            <div class="labels">尺寸</div>
                            <div class="con-box">
                                <div class="lists" :class="{active: item == aiObj.size}" @click="aiObj.size = item" v-for="(item,index) in size" :key="index"><img :src="require(`@/assets/img/size_${item}.png`)"/></div>
                            </div>
                        </div>
                    </div>
                </template>
            </Steps>
            <!-- 第五步 -->
            <Steps
                v-if="step5"
                title="選擇影片設定"
                :isShowArrow="true"
                :isLast="true"
                @clickBack="onClickPreTo(4)"
                @onClickFinish="onClickFinish"
            >
                <template slot="body">
                    <div class="select-scene-wrap">
                        <van-checkbox icon-size="16px" shape="square" v-model="isAuto" @change="changeAuto">預設開啟（進入場景自動播放）</van-checkbox>
                        <div class="select-scene-box">
                            <van-radio-group icon-size="16px" v-model="sceneTab" direction="horizontal">
                                <van-radio name="1">應用到全局</van-radio>
                                <van-radio name="2">應用到場景</van-radio>
                            </van-radio-group>
                            <!--scene-->
                            <div
                                class="scroll-base"
                                v-if="sceneTab == '2'"
                            >
                                <div class="item-wrapper">
                                    <ImageItem
                                        :itemObj="value"
                                        v-for="(value, k) in allScenes"
                                        :key="k"
                                        :selected="selectedScene"
                                        @click.native="selectScene(value)"
                                    ></ImageItem>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Steps>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import digitalHuman from "../../../../../public/ssr/components/digitalHuman/Index";
    import MaterialSelect from "@/components/MaterialSelect";
    import Steps from "../Steps.vue";
    import ImageItem from "../ImageItem.vue";
    import Color from "./component/Color";
    import {v4 as uuidv4} from "uuid";
    import Vue from 'vue';
    import {Checkbox, RadioGroup, Radio } from 'vant';
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(Checkbox);
    const defaultObj = {
        anchor_url: "", // 主播影片地址
        speech_explain_url: "",// 語音地址
        speech_explain_name: "",// 語音名稱
        is_auto: 1,// 自動播放
        color: "RGB(0,0,0)", // 顔色
        position: "left", // 位置
        size: "s",// 尺寸
    }
    export default {
        components: {digitalHuman, MaterialSelect, Steps, ImageItem,Color},
        data() {
            return {
                aiObj:{
                    anchor_url: "", // 主播影片地址https://tainan720.s3.ap-southeast-1.amazonaws.com/1/web/video/o_1h9pafp8a7gt1cl913locer1bf7h.mp4
                    speech_explain_url: "",// 語音地址
                    speech_explain_name: "",// 語音名稱
                    is_auto: 1,// 自動播放
                    color: "RGB(0,0,0)", // 顔色
                    position: "left", // 位置
                    size: "s",// 尺寸
                },
                position: ['left','right'],
                size: ['s','m','l'],

                speechPlay: false,
                videoPlay: false,

                // ai主播組件所需
                videoDom: null,
                videoUrl: "",

                isAuto: false,
                sceneTab: "1",
                selectedScene: [],

                step1: true,
                step2: false,
                step3: false,
                step4:false,
                step5: false,
            };
        },
        computed: {
            ...mapGetters(["vrbase", "currentScenesId"]),
            newAiObj(){
                return this.$deepClone(this.aiObj)
            },
            allScenes() {
                return this.vrbase.scenes;
            },
        },
        watch: {
            newAiObj:{
                handler(newv,oldv){
                    this.changeAiAnchor(newv,oldv)
                },
                deep: true
            },
            sceneTab:{
                handler(newv){
                    this.selectedScene = []
                    if(newv == '1'){
                        this.selectedScene = Object.values(this.allScenes)
                    }
                },immediate: true
            }
        },
        mounted() {
            this.videoDom = this.$refs.videoDoms
            // 監聽ai主播被點擊播放還是暫停
            window.updateVideoStatus = this.updateVideo
        },
        methods: {
            // 初始化完成
            videoDomLoaded(){
                this.handleInitListData();
            },
            // 這裡過濾掉scene類型的數據
            handleInitListData() {
                const data = this.vrbase.scenes[this.currentScenesId]
                if(data && Object.keys(data.ai_anchor).length) {
                    if(data.ai_anchor.anchor_url != this.aiObj.anchor_url) this.videoPlay = false
                    if(data.ai_anchor.speech_explain_url != this.aiObj.speech_explain_url) this.speechPlay = false
                    this.aiObj = this.$deepClone(data.ai_anchor)
                }else{
                    this.aiObj = this.$deepClone(defaultObj)
                    this.speechPlay = false
                    this.videoPlay = false
                }
                this.isAuto = this.aiObj.is_auto ? true : false
            },
            // ai主播數據的改變觸發事件
            changeAiAnchor(newv,oldv){
                let data = { type: "", value: newv }
                if (newv.anchor_url != oldv.anchor_url){ // 修改了主播影片路徑
                    this.videoUrl = newv.anchor_url + '?v=' + uuidv4()
                    data.type = newv.anchor_url == "" ? "del" : "add"
                } else if (newv.color != oldv.color && newv.color){ // 修改了背景色
                    data.type = "color"
                } else if (newv.position != oldv.position){ // 改變了位置
                    data.type = "position"
                } else if (newv.size != oldv.size){ // 改變了大小
                    data.type = "size"
                }
                if(data.type == "") return
                window.updateAiAnchor(data)
            },
            onClickPreTo(value) {
                if (value === 1) {
                    this.step1 = true;
                    this.step2 = false;
                    this.step3 = false;
                } else if (value === 2) {
                    this.step1 = false;
                    this.step2 = true;
                    this.step3 = false;
                } else if (value === 3) {
                    this.step1 = false;
                    this.step2 = false;
                    this.step3 = true;
                    this.step4 = false;
                }else if (value === 4) {
                    this.step1 = false;
                    this.step2 = false;
                    this.step3 = false;
                    this.step4 = true;
                    this.step5 = false;
                }
            },
            onClickNextTo(value) {
                if (value === 2) {
                    if (!this.aiObj.anchor_url) {
                        this.$message.error("請先選擇影片");
                        return;
                    }
                    this.step1 = false;
                    this.step2 = true;
                    this.step3 = false;
                } else if (value === 3) {
                    this.step1 = false;
                    this.step2 = false;
                    this.step3 = true;
                } else if (value === 4) {
                    this.step1 = false;
                    this.step2 = false;
                    this.step3 = false;
                    this.step4 = true;
                }else if (value === 5) {
                    this.step1 = false;
                    this.step2 = false;
                    this.step3 = false;
                    this.step4 = false;
                    this.step5 = true;
                }
            },
            // 選擇影片
            handleSelectedVideo(item){
                if(this.aiObj.anchor_url && this.videoPlay) {
                    this.playVideoDom(this.videoPlay)
                    const myVideo = document.getElementById("myVideo")
                    myVideo.pause()
                    this.videoPlay = false
                }
                this.aiObj.anchor_url = item.url
            },
            // 播放影片
            playVideo(){
                this.playVideoDom(this.videoPlay)
                const myVideo = document.getElementById("myVideo")
                if(this.videoPlay){
                    myVideo.pause()
                    this.videoPlay = false
                }else{
                    myVideo.play()
                    this.videoPlay = true
                }
            },
            // 切換影片狀態
            updateVideo(type){
                const myVideo = document.getElementById("myVideo")
                const speechAudio = document.getElementById("speechAudio")
                if(type){
                    if(myVideo) myVideo.play()
                    this.videoPlay = true
                    if(speechAudio) speechAudio.pause()
                    this.speechPlay = false
                }else{
                    if(myVideo) myVideo.pause()
                    this.videoPlay = false
                }
            },
            // 接收播放暫停影片
            playVideoDom(type){
                window.editUpdateVideoStatus(type) // 掛載影片播放暫停方法
                const videoDoms = document.getElementById('videoDoms')
                if(type){
                    videoDoms.pause()
                }else{
                    videoDoms.play()
                }
            },
            // 刪除影片
            delVideo(){
                this.aiObj.anchor_url = ""
                this.videoPlay = false
                this.onClickFinish()
            },
            //選擇語音
            handleSelectedAudio(value){
                this.aiObj.speech_explain_url = value.url
                this.aiObj.speech_explain_name = value.name
            },
            //刪除語音解說
            delSpeech(){
                this.aiObj.speech_explain_url = ""
                this.aiObj.speech_explain_name = ""
                this.speechPlay = false
            },
            //播放語音解說
            playSpeech(){
                const speechAudio = document.getElementById("speechAudio")
                if(this.speechPlay){
                    speechAudio.pause()
                    this.speechPlay = false
                }else{
                    speechAudio.play()
                    this.speechPlay = true
                    if(this.videoPlay){
                        this.playVideoDom(this.videoPlay)
                        this.videoPlay = false
                    }
                }
            },
            //修改顏色
            changeColor(color){
                this.aiObj.color = color
            },
            //rgb轉爲16進制
            setColor(rgb){
                if (!rgb) rgb = 'rgb(0,0,0)'
                var regexp = /[0-9]{0,3}/g
                var res = rgb.match(regexp) // 利用正则表达式去掉多余的部分，将rgb中的数字提取
                var hexRes = '#'
                var hex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']
                var hexArr = []
                for (let i = 0; i < res.length; i++) {
                    if (res[i]) {
                        if (res[i] > 16) {
                            let leftIndex = (res[i] / 16) >> 0 // 向下取整
                            let rightIndex = +res[i] % 16
                            hexArr.push(hex[leftIndex])
                            hexArr.push(hex[rightIndex])
                        } else {
                            hexArr.push(0)
                            hexArr.push(hex[res[i]])
                        }
                    }
                }
                return hexRes += hexArr.join('')  // #EDEDED
            },
            //改變是否自動播放
            changeAuto(boolean){
                this.aiObj.is_auto = boolean ? 1 : 0
            },
            //選擇場景
            selectScene(item) {
                if (this.selectedScene.includes(item)) {
                    var index = this.selectedScene.indexOf(item);
                    if (index > -1) {
                        this.selectedScene.splice(index, 1);
                    }
                } else {
                    this.selectedScene.push(item);
                }
            },
            //完成
            onClickFinish(){
                let newIds = [this.currentScenesId]
                this.selectedScene.forEach(obj => {
                    if(obj.id != this.currentScenesId){
                        newIds.push(obj.id)
                    }
                })
                console.log('newIds =>',newIds)
                let vrbase = this.$deepClone(this.vrbase)
                const sceneKeys = Object.keys(vrbase.scenes)
                sceneKeys.forEach(obj=>{
                    if(newIds.includes(obj)){
                        if(this.aiObj.anchor_url || this.aiObj.speech_explain_url){
                            vrbase.scenes[obj].ai_anchor = this.$deepClone(this.aiObj)
                        }else{
                            vrbase.scenes[obj].ai_anchor = this.$deepClone(defaultObj)
                        }
                    }
                })

                console.log('vrbase =>',vrbase)
                this.closeAll()
                this.$store.dispatch("setVRBase", vrbase)
                this.$store.dispatch("saveVRBase",{ vrbase, showLoading: true,})
            },
            //關閉
            closeAll(){
                this.step1 = true
                this.step2 = false
                this.step3 = false
                this.step4 = false
                this.step5 = false
            }
        },
    };
</script>

<style lang="less" scoped>
    .mob-inject{
        padding: 0 !important;
        .ai-show-wrap{
            position: relative;
            .video-wrap{
                position: absolute;
                right: 0;
                bottom: 0;
                overflow: hidden;
            }
        }
        .add-box{
            display: block;
            overflow: hidden;
        }

        .base-container{
            width: 100%;
            padding: 0;
            .rights-box{
                display: flex;
                align-items: center;
                .adds{
                    padding: 4px 14px;
                    border-radius: 4px;
                    border: 1px dashed #333;
                    background-color: #444;
                    margin-left: 5px;
                }
            }
        }
        .select-scene-wrap{
            width: 100%;
            padding: 8px 0;

            /deep/ .van-checkbox__label, /deep/ .van-radio__label{
                color: #ffffff;
            }
            .select-scene-box{
                padding-top: 10px;
                margin-top: 10px;
                .scroll-base{
                    padding: 10px;
                    background-color: rgba(0,0,0,.08);
                    border-radius: 5px;
                }
            }
        }

        .video-box{
            width: 50px;
            height: 50px;
            background-color: #222;
            position: relative;
            .video-play-btn{
                position: absolute;
                top: 50%;
                left: 50%;
                z-index: 10;
                transform: translate(-50%,-50%);
                width: 34px;
                height: 34px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                cursor: pointer;
                user-select: none;
                transition: background-color .3s ease;
                &:hover{
                    background-color: rgba(0,0,0,.8);
                }
                .anticon{
                    font-size: 22px;
                    color: #ffffff;
                }
            }
        }

        .audio-box{
            display: flex;
            align-items: center;
            background-color: #2b2b2b;
            padding: 0 5px;
            height: 52px;
            justify-content: center;
            border-radius: 4px;
            flex: 1;
            overflow: hidden;
            .tips{
                font-size: 14px;
                color: #aaa;
            }
            .play-btn{
                width: 42px;
                height: 42px;
                position: relative;
                background-color: #444;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                margin-right: 10px;
                cursor: pointer;
                user-select: none;
                .anticon{
                    font-size: 24px;
                    color: #ffffff;
                }
            }
            .right-info{
                flex: 1;
                overflow: hidden;
                .names{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 13px;
                    color: #ffffff;
                }
            }
        }

        .color-wrap{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0;
            .color-box{
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #ffffff;
                font-size: 14px;
                .boxs{
                    flex: 1;
                    margin-left: 30px;
                    background-color: rgba(255,255,255,.2);
                    height: 28px;
                    display: flex;
                    align-items: center;
                    color: #ffffff;
                    padding: 0 5px;
                    .color-k{
                        width: 20px;
                        height: 20px;
                        flex-shrink: 0;
                        margin-right: 10px;
                        background-color: #000000;
                    }
                }
            }

        }

        .position-box{
            flex: 1;
            padding: 10px 0;
            .set-box{
                margin-top: 12px;
                display: flex;
                align-items: center;
                &:first-child{
                    margin-top: 0;
                }
                .labels{
                    font-size: 14px;
                    color: #ffffff;
                    margin-right: 20px;
                    flex-shrink: 0;
                }
                .con-box{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 36px;
                    background-color: rgba(0,0,0,.5);
                    border-radius: 4px;
                    padding: 2px;
                    .lists{
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                        &.active{
                            background-color: #015c61;
                            border-radius: 3px;
                        }
                    }
                }
            }
        }
    }
</style>
